<template>
  <footer class="bg-gray-900 text-gray-300 py-16 px-6 md:px-12">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
      <div>
        <h3 class="text-2xl font-extrabold mb-5 text-white">
          {{ $t('footer.brand.name') }}
        </h3>
        <p class="text-base leading-relaxed text-gray-400">
          {{ $t('footer.brand.description') }}
        </p>
        <div class="flex space-x-5 mt-7">
          <a class="text-gray-400 hover:text-purple-500 transition duration-300" href="javascript:void(0);">
            <i class="fab fa-linkedin-in text-2xl">
            </i>
          </a>
          <a class="text-gray-400 hover:text-purple-500 transition duration-300" href="javascript:void(0);">
            <i class="fab fa-twitter text-2xl">
            </i>
          </a>
          <a class="text-gray-400 hover:text-purple-500 transition duration-300" href="javascript:void(0);">
            <i class="fab fa-facebook-f text-2xl">
            </i>
          </a>
          <a class="text-gray-400 hover:text-purple-500 transition duration-300" href="javascript:void(0);">
            <i class="fab fa-wechat text-2xl">
            </i>
          </a>
        </div>
      </div>
      <div class="text-center">
        <h3 class="text-xl font-bold mb-5 text-white">
          {{ $t('footer.quickLinks.title') }}
        </h3>
        <ul class="space-y-3">
          <li>
            <router-link to="/" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.home') }}
            </router-link>
          </li>
          <li>
            <router-link to="/about" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.about') }}
            </router-link>
          </li>
          <li>
            <router-link to="/service" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.coreService') }}
            </router-link>
          </li>
          <li>
            <router-link to="/product" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.industrySolutions') }}
            </router-link>
          </li>
          <li>
            <router-link to="/case-studies" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.caseStudies') }}
            </router-link>
          </li>
          <li>
            <router-link to="/resource-center" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.resourceCenter') }}
            </router-link>
          </li>
          <li>
            <router-link to="/customer-support" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.customerSupport') }}
            </router-link>
          </li>
          <li>
            <router-link to="/contact" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.quickLinks.contact') }}
            </router-link>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="text-xl font-bold mb-5 text-white">
          {{ $t('footer.solutions.title') }}
        </h3>
        <ul class="space-y-3">
          <li>
            <router-link to="/product#finance" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.solutions.finance') }}
            </router-link>
          </li>
          <li>
            <router-link to="/product#ticket-ai" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.solutions.ticketAI') }}
            </router-link>
          </li>
          <li>
            <router-link to="/product#manufacturing" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.solutions.manufacturing') }}
            </router-link>
          </li>
          <li>
            <router-link to="/product#healthcare" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.solutions.healthcare') }}
            </router-link>
          </li>
          <li>
            <router-link to="/product#government" class="text-gray-400 hover:text-white transition duration-300">
              {{ $t('footer.solutions.government') }}
            </router-link>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="text-xl font-bold mb-5 text-white">
          {{ $t('footer.contactInfo.title') }}
        </h3>
        <p class="text-base mb-3 text-gray-400">
          <i class="fas fa-map-marker-alt mr-3 text-purple-400">
          </i>
          {{ $t('footer.contactInfo.address') }}
        </p>
        <p class="text-base mb-3 text-gray-400">
          <i class="fas fa-envelope mr-3 text-purple-400">
          </i>
          info@global-data.com
        </p>
      </div>
    </div>
    <div class="border-t border-gray-700 mt-12 pt-8 text-center text-base text-gray-500">
      <p>{{ $t('footer.copyright') }}</p>
    </div>
  </footer>
</template>
<script setup></script>
